import HttpWrapper from '../HttpWrapper'
import {
    GetLLMSettingsRes,
    LLMSettingsName,
    SaveLLMSettingsReq,
    GenerateBooleanQueryFromJobSpecReq,
    GenerateBooleanQueryFromJobSpecRes,
} from './models'

class LLMSettingsApi {
    public async getLLMSettings(
        name: LLMSettingsName,
    ): Promise<GetLLMSettingsRes> {
        const params = new URLSearchParams({ name })
        return await HttpWrapper.get<GetLLMSettingsRes>(
            '/llm-settings/',
            params,
        )
    }

    public async saveLLMSettings(req: SaveLLMSettingsReq): Promise<void> {
        await HttpWrapper.post<SaveLLMSettingsReq, void>(
            '/llm-settings/save',
            req,
        )
    }

    public async generateBooleanQueryFromJobSpec(
        req: GenerateBooleanQueryFromJobSpecReq,
    ): Promise<GenerateBooleanQueryFromJobSpecRes> {
        return await HttpWrapper.post<
            GenerateBooleanQueryFromJobSpecReq,
            GenerateBooleanQueryFromJobSpecRes
        >('/llm-settings/generate-boolean-query', req)
    }
}

const llmSettingsApi = new LLMSettingsApi()
export default llmSettingsApi
